const REQUEST_LEADS_OVERVIEW = 'platfi-ui-app/DASHBOARD/REQUEST_LEADS_OVERVIEW';
const REQUEST_LEADS_OVERVIEW_SUCCESS = 'platfi-ui-app/DASHBOARD/REQUEST_LEADS_OVERVIEW_SUCCESS';
const REQUEST_LEADS_OVERVIEW_FAILURE = 'platfi-ui-app/DASHBOARD/REQUEST_LEADS_OVERVIEW_FAILURE';

export { REQUEST_LEADS_OVERVIEW, REQUEST_LEADS_OVERVIEW_SUCCESS, REQUEST_LEADS_OVERVIEW_FAILURE };
